var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_6957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 0H7.04167C5.54829 0 4.33333 1.21496 4.33333 2.70833V5.95833C4.33333 7.45171 5.54829 8.66667 7.04167 8.66667H10.2917C11.785 8.66667 13 7.45171 13 5.95833V2.70833C13 1.21496 11.785 0 10.2917 0ZM11.9167 5.95833C11.9167 6.85425 11.1876 7.58333 10.2917 7.58333H7.04167C6.14575 7.58333 5.41667 6.85425 5.41667 5.95833V2.70833C5.41667 1.81242 6.14575 1.08333 7.04167 1.08333H10.2917C11.1876 1.08333 11.9167 1.81242 11.9167 2.70833V5.95833ZM8.66667 10.2917C8.66667 11.785 7.45171 13 5.95833 13H2.70833C1.21496 13 0 11.785 0 10.2917V7.04167C0 5.54829 1.21496 4.33333 2.70833 4.33333C3.00788 4.33333 3.25 4.576 3.25 4.875C3.25 5.174 3.00788 5.41667 2.70833 5.41667C1.81242 5.41667 1.08333 6.14575 1.08333 7.04167V10.2917C1.08333 11.1876 1.81242 11.9167 2.70833 11.9167H5.95833C6.85425 11.9167 7.58333 11.1876 7.58333 10.2917C7.58333 9.99267 7.82546 9.75 8.125 9.75C8.42454 9.75 8.66667 9.99267 8.66667 10.2917Z",
    fill: "#DE1186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_6957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneActiveIcon);
export default __webpack_public_path__ + "static/media/clone-active-icon.a042ab1ee825cc574395cf11790a4dcf.svg";
export { ForwardRef as ReactComponent };